// extracted by mini-css-extract-plugin
export default {"title":"StampsForeignInfo_title__KN1a9","row":"StampsForeignInfo_row__EF-nF","mainContainer":"StampsForeignInfo_mainContainer__6Zc+d","fontSize":"StampsForeignInfo_fontSize__xGdrZ"};